import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UserManagementPage from './UserManagementPage.jsx';

export default function UserManagementRoutes() {
  return (
    <Routes>
      <Route index element={<UserManagementPage />} />
    </Routes>
  );
}
